import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';

@Component({
  templateUrl: 'select.template.component.html'
})
export class SelectTemplateComponent implements OnInit {
  codSubscription: string;
  codChannel: string;

  constructor(private aRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.codSubscription = params['codsistema'];
      this.codChannel = params['codnegocio'];
    });
  }

  asociarAChannel(item) {
    this.router.navigate(['./confAssets'], { relativeTo: this.aRoute });
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/channels/alias/select.template.component.ts